define.alias("ember-power-select/helpers/ember-power-select-is-group", "settings/helpers/ember-power-select-is-group");